export async function isValidAbrange(
  abrangencia: any[],
  ufId: string,
): Promise<boolean> {
  try {
    const existe = abrangencia.find(x => String(x.id_uf_r) === ufId);
    if (!existe) {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
